import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconItalicStyle0 = gravityIconIndividualCss;

const GravityIconItalic = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '7ea5df6a43cacfb2900f44d4521b2af8aeb61a3d', color: this.color, size: this.size }, h("svg", { key: '34fd0900be525d6de3be79ad0d5d126ac40d0f24', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '850d50a0c8bd73212044bb917865c3f6b4956d04', d: "M8 4.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H13l-1 10h1.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H9l1-10H8.5a.5.5 0 0 1-.5-.5v-1Z", fill: "currentColor" }))));
    }
};
GravityIconItalic.style = GravityIconItalicStyle0;

export { GravityIconItalic as gravity_icon_italic };

//# sourceMappingURL=gravity-icon-italic.entry.js.map